import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';

const GridContainer = styled.div`
  width: ${Spacings.APP_CONTAINER_WIDTH};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    display: flex;
    padding-right: ${Spacings.SPACING_4B};
    padding-left: ${Spacings.SPACING_4B};
    padding-bottom: ${Spacings.SPACING_8B};
    padding-top: ${Spacings.SPACING_8B};
    border-bottom: solid ${Spacings.SPACING_2B} var(--color-violet-1);
  }
  margin: auto;
  display: grid;
  z-index: 0;
  grid-template-columns: repeat(24, 1fr);
  grid-column-gap: ${Spacings.SPACING_4B};
  justify-content: center;
`;

export default GridContainer;
